import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UpdateDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"update_disabled"}/>
}
